import argentinaImage from "../../static/original-images/Argentina.jpeg";
import boliviaImage from "../../static/original-images/Bolivia.jpg";
import canadaImage from "../../static/original-images/Canada.png";
import chileImage from "../../static/original-images/Chile.jpg";
import colombiaImage from "../../static/original-images/Colombia.jpg";
import costaRicaImage from "../../static/original-images/CostaRica.jpg";
import cyprusImage from "../../static/original-images/Cyprus.jpg";
import elSalvadorImage from "../../static/original-images/ElSalvador.jpeg";
import estoniaImage from "../../static/original-images/Estonia.jpg";
import germanyImage from "../../static/original-images/Germany.jpg";
import greeceImage from "../../static/original-images/Greece.png";
import hungaryImage from "../../static/original-images/Hungary.jpg";
import indonesiaImage from "../../static/original-images/Indonesia.jpg";
import kyrgyzstanImage from "../../static/original-images/Kyrgyzstan.jpg";
import luxembourgImage from "../../static/original-images/Luxembourg.jpg";
import mexicoImage from "../../static/original-images/Mexico.png";
import pakistanImage from "../../static/original-images/Pakistan.jpg";
import paraguayImage from "../../static/original-images/Paraguay.jpg";
import switzerlandImage from "../../static/original-images/Switzerland.png";
import turkeyImage from "../../static/original-images/Turkey.jpg";
import usaImage from "../../static/original-images/USA.jpg";

const initialState = [
  {
    id: "argentina",
    name: "Argentina",
    src: argentinaImage,
  },
  {
    id: "bolivia",
    name: "Bolivia",
    src: boliviaImage,
  },
  {
    id: "canada",
    name: "Canada",
    src: canadaImage,
  },
  {
    id: "chile",
    name: "Chile",
    src: chileImage,
  },
  {
    id: "colombia",
    name: "Colombia",
    src: colombiaImage,
  },
  {
    id: "costaRica",
    name: "CostaRica",
    src: costaRicaImage,
  },
  {
    id: "cyprus",
    name: "Cyprus (northern part)",
    src: cyprusImage,
  },
  {
    id: "salvador",
    name: "El Salvador",
    src: elSalvadorImage,
  },
  {
    id: "estonia",
    name: "Estonia",
    src: estoniaImage,
  },
  {
    id: "germany",
    name: "Germany",
    src: germanyImage,
  },
  {
    id: "greece",
    name: "Greece",
    src: greeceImage,
  },
  {
    id: "hungary",
    name: "Hungary",
    src: hungaryImage,
  },
  {
    id: "indonesia",
    name: "Indonesia",
    src: indonesiaImage,
  },
  {
    id: "kyrgyzstan",
    name: "Kyrgyzstan",
    src: kyrgyzstanImage,
  },
  {
    id: "luxembourg",
    name: "Luxembourg",
    src: luxembourgImage,
  },
  {
    id: "mexico",
    name: "Mexico",
    src: mexicoImage,
  },
  {
    id: "pakistan",
    name: "Pakistan",
    src: pakistanImage,
  },
  {
    id: "paraguay",
    name: "Paraguay",
    src: paraguayImage,
  },
  {
    id: "switzerland",
    name: "Switzerland",
    src: switzerlandImage,
  },
  {
    id: "turkey",
    name: "Turkey",
    src: turkeyImage,
  },
  {
    id: "usa",
    name: "U.S.A",
    src: usaImage,
  },
];

const originalImageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_ORIGIN_IMAGES":
      return payload;
    default:
      return state;
  }
};

export default originalImageReducer;
